import WelcomeSection from './WelcomeSection.container';

export default WelcomeSection;
